import { NotificationType } from "@capacitor/haptics";
import { Haptics } from "./plugins";
import { innerWindow } from "./elements";
import { autoTranslate } from "./translate";
import { getLogger } from "./logging";

const log = getLogger("📣 Snackbar");

const SnackBar = innerWindow.Snackbar;

if (!SnackBar) log.error("No snackbar found");

const config = {
  pos: "bottom-center",
  actionText: "DISMISS",
  duration: 5000,
  actionTextColor: "black",
  backgroundColor: "#FE7A7E",
  textColor: "black",
  //   borderColor: "black",
  //   borderStyle: "solid",
  //   borderWidth: "0.6vmin",
};

export const showErrorSnackbar = (text, extraConfig = {}, error) => {
  log.error(text);
  if (error && __DEV__) log.error(error);
  if (SnackBar) {
    SnackBar.show({
      text,
      ...config,
      actionText: "DISMISS",
      backgroundColor: "#FE7A7E",
      ...extraConfig,
    });
    Haptics.notification({ type: NotificationType.Error });
    autoTranslate();
  }
};

export const showWarningSnackbar = (text, extraConfig = {}) => {
  log.warn(text);
  if (SnackBar) {
    SnackBar.show({
      text,
      ...config,
      actionText: "OK",
      backgroundColor: "#ffe602",
      ...extraConfig,
    });
    Haptics.notification({ type: NotificationType.Warning });
    autoTranslate();
  }
};

export const showSuccessSnackbar = (text, extraConfig = {}) => {
  log.info(text);
  if (SnackBar) {
    SnackBar.show({
      text,
      ...config,
      actionText: "OK",
      backgroundColor: "#D3FF02",
      ...extraConfig,
    });
    Haptics.notification({ type: NotificationType.Success });
    autoTranslate();
  }
};

export const showInfoSnackbar = (text, extraConfig = {}) => {
  log.info(text);
  if (SnackBar) {
    SnackBar.show({
      text,
      ...config,
      actionText: "OK",
      backgroundColor: "#02f2ff",
      ...extraConfig,
    });
    Haptics.notification({ type: NotificationType.Success });
    autoTranslate();
  }
};

if (__DEV__) {
  window.showErrorSnackbar = showErrorSnackbar;
  window.showSuccessSnackbar = showSuccessSnackbar;
}
